/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {assert} from 'Asserts';
import * as benchlingUtil from 'BenchlingUtil';
import * as logging from 'util/Logging';

export default function (viewClassName, key, viewInstance, e) {
  assert(viewInstance[key] == null);

  // T4850: There is a "restore session" feature in Firefox that reloads open pages and resets inputs to their
  // previously values (even if they are not visible) on page load. However, we have singleton backbone views
  // (toolbar panels) that start listening to the DOM on page load. This feature ends up triggering handlers
  // before the panel is expecting user interaction. When all panels are migrated over to React, this will
  // be a non-issue, so we silently ignore for now. See: https://bugzilla.mozilla.org/show_bug.cgi?id=464691
  if (benchlingUtil.firefox) {
    return;
  }

  logging.error(`${key} is undefined in ${viewClassName}`, {
    extra: {
      this: Object.keys(viewInstance),
      e: e != null ? {type: e.type, which: e.which, outerHTML: e.target.outerHTML} : null,
    },
  });
}
